<section class="login-block">
  <!-- Container-fluid starts -->
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <!-- Authentication card start -->
        <form  novalidate #loginForm="ngForm" (submit)="loginForm.valid && submitLogin()">
          <div class="text-center">
            <img class="header-logo" src="../../../assets/images/urbansofa_logo_white.png" alt="logo.png">
          </div>
          <div class="auth-box card">
            <div class="card-block">
              <div class="row m-b-20">
                <div class="col-md-12">
                  <h3 class="text-center">{{'auth.verificatie'|translate}}</h3>
                </div>
              </div>
              <div class="form-group form-primary">
                <label class="float-label">{{'auth.enter.code'|translate}}</label>
                <input type="text" name="verifyCode" #verifyCode="ngModel" [(ngModel)]="login.auth_code" class="form-control" minlength="6" maxlength="6" required autofocus>
                <span class="form-bar"></span>
                <div class="messages text-danger" *ngIf="verifyCode.invalid && verifyCode.dirty && verifyCode.errors?.required">{{'errors.required'|translate}}</div>
                </div>
              <div class="row m-t-30">
                <div class="col-md-12">
                  <button [disabled]="!loginForm.valid || isSubmitting" [ngClass]="{'btn-disabled': !loginForm.valid, 'disabled': !loginForm.valid}" type="submit" class="btn btn-primary btn-md btn-block text-center m-b-20 ripple light">{{'auth.to_confirm'|translate}}</button>
                </div>
              </div>
              <hr/>
              <div class="row">
                <div class="col-md-12">
                  <a href="https://www.urbansofa.nl/">
                    <span class="text-inverse text-start m-b-0">https://www.urbansofa.nl/</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </form>
        <!-- end of form -->
      </div>
      <!-- end of col-sm-12 -->
    </div>
    <!-- end of row -->
  </div>
  <!-- end of container-fluid -->
</section>
